
import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import UserRow from './UserRow';
import EmptyUsersList from './EmptyUsersList';
import { User } from './hooks/useUsersList';

type UsersListTableProps = {
  users: User[];
  isDeleting: boolean;
  onEditUser: (userId: string, email: string) => void;
  onSetAdminRole: (email: string) => Promise<void>;
  onDeleteUser: (userId: string, email: string) => Promise<void>;
  onToggleActive: (userId: string, isActive: boolean) => Promise<void>;
};

const UsersListTable: React.FC<UsersListTableProps> = ({
  users,
  isDeleting,
  onEditUser,
  onSetAdminRole,
  onDeleteUser,
  onToggleActive
}) => {
  // Logging pour débugger le problème d'affichage
  console.log('Rendering UsersListTable with users:', users.length, JSON.stringify(users, null, 2));
  
  return (
    <div>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Nom</TableHead>
            <TableHead>Email</TableHead>
            <TableHead>Email vérifié</TableHead>
            <TableHead>Rôle</TableHead>
            <TableHead>Forfait</TableHead>
            <TableHead>Statut</TableHead>
            <TableHead>Date d'inscription</TableHead>
            <TableHead>Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {users.length === 0 ? (
            <EmptyUsersList />
          ) : (
            users.map((user) => (
              <UserRow 
                key={user.id}
                user={user}
                isDeleting={isDeleting}
                onEdit={onEditUser}
                onSetAdminRole={onSetAdminRole}
                onDeleteUser={onDeleteUser}
                onToggleActive={onToggleActive}
              />
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default UsersListTable;
